import moment from 'moment';
import React from 'react'
import { Table } from 'react-frontier';
import { Link } from 'react-router-dom';

interface UserLogProps {
	user: {
		user_id?: number,
		user_creator?: any,
		user_creator_name?: string,
		date_created?: number,

		approved?: boolean,
		user_approved?: number,
		user_approver_name?: string,
		date_approved?: number,

		verified?: boolean,
		user_verified?: number,
		user_verified_name?: string,
		date_verified?: number,

		completed?: boolean,
		user_completed?: number,
		user_completed_name?: string,
		date_completed?: number,

		cancelled?: boolean,
		user_cancelled?: number,
		user_cancelled_name?: string,
		date_cancelled?: number,

		deleted?: boolean,
		user_deleted?: number,
		user_deleted_name?: string,
		date_deleted?: number,

		paid?: boolean,
		user_paid?: number,
		user_paid_name?: string,
		date_paid?: number,

		
	},
	style?: React.CSSProperties
	fitted?: boolean,
}

export default function UserLog(props: UserLogProps) {
	var user = props.user;
	if(!user) return null;

	return (
		<Table details striped
			fitted={props.fitted}
			style={{ maxWidth: 400, margin: 'auto', marginTop: 15, ...props.style }}
			title="Usuarios"
			data={[
				...((user.user_id || user.user_creator) ? [
					['Creado', <>
						<Link target='_blank' className='normal' to={`/users/${(user.user_id || user.user_creator)}`}>
							{user.user_creator_name || `Usuario #${(user.user_id || user.user_creator)}`}
						</Link>
						{(user.user_id || user.user_creator) && (
							<div className="meta">ID: {(user.user_id || user.user_creator)}</div>
						)}
					</>]
				] : []),
				['Fecha creación', <>
					{moment.unix(user.date_created).format('DD/MMM/YY HH:mm')}
				</>],
				...(user.approved ? [
					null,
					['Aprobador', <>
						<Link target='_blank' className='normal' to={`/users/${user.user_approved}`}>{user.user_approver_name || `Usuario #${user.user_approved}`}</Link>
						<div className="meta">ID: {user.user_approved}</div>
					</>],
					['Fecha aprobación', <>
						{moment.unix(user.date_approved).format('DD/MMM/YY HH:mm')}
					</>],
				] : []),
				...(user.completed ? [
					null,
					['Completado', <>
						<Link target='_blank' className='normal' to={`/users/${user.user_completed}`}>{user.user_completed_name || `Usuario #${user.user_completed}`}</Link>
						<div className="meta">ID: {user.user_completed}</div>
					</>],
					['Fecha completada', <>
						{moment.unix(user.date_completed).format('DD/MMM/YY HH:mm')}
					</>],
				] : []),
				...(user.paid ? [
					null,
					['Pagado', <>
						<Link target='_blank' className='normal' to={`/users/${user.user_paid}`}>{user.user_paid_name || `Usuario #${user.user_paid}`}</Link>
						<div className="meta">ID: {user.user_paid}</div>
					</>],
					['Fecha pagado', <>
						{moment.unix(user.date_paid).format('DD/MMM/YY HH:mm')}
					</>],
				] : []),
				...(user.cancelled ? [
					null,
					['Cancelado', <>
						<Link target='_blank' className='normal' to={`/users/${user.user_cancelled}`}>{user.user_cancelled_name || `Usuario #${user.user_cancelled}`}</Link>
						<div className="meta">ID: {user.user_cancelled}</div>
					</>],
					['Fecha cancelado', <>
						{moment.unix(user.date_cancelled).format('DD/MMM/YY HH:mm')}
					</>],
				] : []),
				...(user.deleted ? [
					null,
					['Eliminado', <>
						<Link target='_blank' className='normal' to={`/users/${user.user_deleted}`}>{user.user_deleted_name || `Usuario #${user.user_deleted}`}</Link>
						<div className="meta">ID: {user.user_deleted}</div>
					</>],
					['Fecha eliminado', <>
						{moment.unix(user.date_deleted).format('DD/MMM/YY HH:mm')}
					</>],
				] : []),
			]}
		/>
	)
}